<template>
  <div class="grid bg-white">
    <div class="grid-body">
      <invoice-top :invoice="invoice" title="UPDATE INVOICE" />
      <item-list :items="invoice.items" :invoice="invoice" :files="files" />

      <div class="row mt-10">
        <div class="col-md-12">
          <button class="btn btn-success btn-block" @click="save()">
            <i class="fa fa-floppy-o" aria-hidden="true"></i> Submit
          </button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import InvoiceTop from "./Components/InvoiceTop";
import ItemList from "./Components/ItemList";
import moment from "moment";
import itemCheck from "./Tools/itemCheck";
import Swal from "sweetalert2";

export default {
  components: {
    InvoiceTop,
    ItemList,
  },
  data() {
    return {
      format: "YYYY-MM-DDT00:00:00.000+07:00",
      formatWithTime: "YYYY-MM-DDTHH:mm:ss.000+07:00",
      invoice: {
        items: [],
        account: {},
      },
      files: [],
    };
  },
  mounted() {
    this.getInvoice();
  },
  watch: {
    $route() {
      location.reload();
    },
  },
  methods: {
    async getInvoice() {
      let res = await axios.get(
        "accounting/invoice/" + this.$route.params.id + "/edit"
      );
      let invoice = res.data;
      invoice.transaction_date_time = moment(
        invoice.transaction_date_time
      ).format(this.formatWithTime);
      invoice.invoice_date = moment(invoice.invoice_date).format(this.format);
      invoice.due_date = moment(invoice.due_date).format(this.format);
      this.invoice = invoice;
    },

    async save() {
      if (!this.invoice.account.id) {
        Swal.fire("ERROR", "Please Select Account", "error");
        return false;
      }

      if (itemCheck.run(this.invoice.items)) {
        const { value: value } = await Swal.fire({
          type: "warning",
          title: "Are You Sure",
          confirmButtonText: "YES",
          showCancelButton: true,
        });
        if (value) {
          $(".loading").show();
          var fd = new FormData();
          fd.append("data", JSON.stringify(this.invoice));
          fd.append("_method", "PATCH");
          this.files.forEach((val) => {
            fd.append("file[]", val);
          });
          try {
            let res = await axios.post(
              "accounting/invoice/" + this.$route.params.id,
              fd
            );
            if (res) {
              $(".loading").hide();
              toastr.success("Success");
              this.$router.push(
                "/accounting/" + this.$route.params.type + "/invoice/list"
              );
            }
          } catch (error) {
            if (error) {
              $(".loading").hide();
              Swal.fire(
                "ERROR",
                "Something Went Wrong <br> Plese Refresh the Page and Try Again!",
                "error"
              );
            }
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.mt-10 {
  margin-top: 10px;
}
</style>
